import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import { ExchangeRate, createChat } from "./FetchExchange";
import { Link, Navigate } from "react-router-dom";
import { updateLimit } from "../store/actions/limitAction";
import KYC from "../assets/images/KYC.svg";
import Popup from "../components/common/Popup";
import { fetchUpdate } from "../routes/FetchData";
import VerificationUser from "../components/features/VerificationUser";
import NewInputExchange from "../components/features/NewInputExchange";
import { listMoneyObj } from "../utils/configData";
import Preview from "./Preview";
import { fetchLogout } from "./FetchAuth";
import { updateUserInfo } from "../store/actions/userAction";
import { removeBankWalletAll } from "../store/actions/bankWalletsAction";
import { removeCryptoWalletAll } from "../store/actions/cryptoWalletsAction";

const NewExchange = () => {
  const { t } = useTranslation();
  const [lastUpdate, setLastUpdate] = useState("Friday 22:28");
  const dispatch = useDispatch();
  const [change, setChange] = useState(true);
  const minimumEuros = useRef(null);
  const [errorShake, setErrorShake] = useState(false);
  // verification sumsub KYC
  const [isPopupOpenVerification, setIsPopupOpenVerification] = useState(false);
  const [token, setToken] = useState("none");

  // const closePopupLimit = () => setPopupOpenIsLimit(false);

  const [method, setMethod] = useState("swift");
  const [isPopupOpenPreview, setIsPopupOpenPreview] = useState(false);
  const closePopupPreview = () => setIsPopupOpenPreview(false);
  const [preview, setPreview] = useState([null, null, null, null, null, null]);
  // State for input values
  const [valueCurr, setValueCurr] = useState("");
  const [valueCrypto, setValueCrypto] = useState("");

  // Вибір початкових валют для обміну
  // START ==>
  const allCurr = listMoneyObj.filter(item => item.isCoin === false);
  const allCoin = listMoneyObj.filter(item => item.isCoin === true);
  const defaultCurr = { ...allCurr[0], isDefault: true };
  const defaultCoin = { ...allCoin[0], isDefault: true };
  const [selectedCurr, setSelectedCurr] = useState(defaultCurr);
  const [selectedCoin, setSelectedCoin] = useState(defaultCoin);
  // <== END

  // State for wallet keys
  const [keyWalletBank, setKeyWalletBank] = useState(null);
  const [keyWalletCoin, setKeyWalletCoin] = useState(null);

  // Refs for input fields
  const refInputBank = useRef(null);
  const refInputCrypto = useRef(null);

  // Redux state
  const bankWalletsInfo = useSelector((state) => state.bankWallets?.bankWallets || []);
  const cryptoWalletsInfo = useSelector((state) => state.cryptoWallets?.cryptoWallets || []);
  const userInfo = useSelector((state) => state.user);
  const [isPopupOpenLimit, setPopupOpenIsLimit] = useState(userInfo.verif === 0 ? true : false);
  // Комісії
  // START ==>
  const [percentFee, setPercentFee] = useState(0.0);
  const [minFee, setMinFee] = useState(0.0);
  const [minTransac, setMinTransac] = useState(0.0);
  const [cryptoHubFee, setCryptoHubFee] = useState(0.0);
  const [exchangeValue, setExchangeValue] = useState(0.0);
  const [pair, setPair] = useState(1);
  // <== END

  // Fetch exchange rates on component mount and every 30 seconds
  // START ==>
  useEffect(() => {
    const updateRates = () => {
      if (!selectedCurr?.type || !selectedCoin?.type) return;
      ExchangeRate(selectedCurr.type, selectedCoin.type, change, method).then((data) => {
        setPair(data.pair);
        setPercentFee(data.method_fee[0]);
        setMinFee(data.method_fee[1]);
        setMinTransac(data.method_fee[2]);
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleTimeString("en-US", {
          weekday: "short",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false, // 24-hour format
        });
        setLastUpdate(formattedDate); // Update the last update time
      });
    };

    updateRates();
    const intervalId = setInterval(updateRates, 30000);
    return () => clearInterval(intervalId);
  }, [selectedCurr.type, selectedCoin.type, change, pair, method]);
  // <== END
  // Reverse swap functionality
  const reverseSwap = () => {
    setChange(!change);
    if (refInputBank.current && refInputCrypto.current) {
      refInputBank.current.style.order = change ? 1 : 0;
      refInputCrypto.current.style.order = change ? 0 : 1;
    }
  };

  // State for chat ID
  const [chatID, setChatID] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const buy_amount = change ? valueCrypto : valueCurr;
    const buy_currency = change ? selectedCoin.type : selectedCurr.type;
    const buy_wallet = change ? keyWalletCoin[1] : keyWalletBank[1];
    const sell_amount = change ? valueCurr : valueCrypto;
    const sell_currency = change ? selectedCurr.type : selectedCoin.type;
    const sell_wallet = change ? keyWalletBank[1] : keyWalletCoin[1];

    setPreview([
      sell_wallet,
      sell_currency,
      sell_amount,
      buy_wallet,
      buy_currency,
      buy_amount,
    ]);
    setIsPopupOpenPreview(true);
  };
  const checkChanges = () => {
    return (
      valueCurr <= minTransac ||
      !valueCurr ||
      !valueCrypto ||
      !keyWalletBank ||
      !keyWalletCoin ||
      valueCurr < 0 ||
      valueCrypto < 0 ||
      valueCurr > bankWalletsInfo[keyWalletBank[0]].balance ||
      valueCrypto > cryptoWalletsInfo[keyWalletCoin[0]].balance
    );
  };

  useEffect(() => {
    console.log("Preview", preview);
  }, [preview])

  const handleExchange = () => {
    const buy_amount = change ? valueCrypto : valueCurr;
    const buy_currency = change ? selectedCoin.type : selectedCurr.type;
    const buy_wallet = change ? keyWalletCoin[1] : keyWalletBank[1];
    const rate = pair;
    const sell_amount = change ? valueCurr : valueCrypto;
    const sell_currency = change ? selectedCurr.type : selectedCoin.type;
    const sell_wallet = change ? keyWalletBank[1] : keyWalletCoin[1];
    const user = userInfo.id;
    minimumEuros.current.classList.remove("active");
    setErrorShake(false);
    if (exchangeValue <= minTransac) {
      minimumEuros.current.classList.add("active");
      setErrorShake(true);

    } else {
      createChat({
        buy_amount,
        buy_currency,
        buy_wallet,
        rate,
        sell_amount,
        sell_currency,
        sell_wallet,
        user,
      }).then((response) => {
        console.log(response.success, "response.success");
        if (response.success) {
          setChatID(response.data.chat_id);
          updateLimit(dispatch, userInfo.id);
          setIsPopupOpenPreview(false);
        } else if (response.status === 403 && response.detail === "transaction.over_limit" && userInfo.verif === 0) {
          setIsPopupOpenPreview(false);
          setPopupOpenIsLimit(true);
        } else if (response.status === 403 && response.detail === "transaction.under_minimal") {
          minimumEuros.current.classList.add("active");
          setErrorShake(true);
        }
      });
    }
  };

  const onChange = useCallback(
    (e, isBank) => {
      if (!pair || pair === 0) return;

      let amount = e;
      if (e === "none") {
        amount = isBank ? valueCurr : valueCrypto;
      }
      if (isNaN(amount)) {
        setValueCurr("");
        setValueCrypto("");
        setCryptoHubFee("0.00");
        setExchangeValue("0.00");
        return;
      }
      const value = change ? isBank ? (amount * pair).toFixed(2) : (amount * 1 / pair).toFixed(2) : !isBank ? (amount * pair).toFixed(2) : (amount * 1 / pair).toFixed(2);
      setValueCurr(isBank ? amount : value);
      setValueCrypto(isBank ? value : amount);
      const percentFeeAmount = parseFloat(isBank ?
        (amount * (percentFee / 100)) : (value * (percentFee / 100))
      ).toFixed(2);
      const fee = Math.max(minFee, percentFeeAmount);
      if (amount >= minTransac) {
        setCryptoHubFee(fee.toFixed(2));


        const exchangeThisValue = change
          ? isBank ? parseFloat(amount) + parseFloat(fee) : parseFloat(value + fee)
          : isBank ? parseFloat(value) : parseFloat(amount) + parseFloat(fee);
        setExchangeValue(parseFloat(exchangeThisValue).toFixed(2));
      } else {
        setCryptoHubFee("0.00");
        setExchangeValue("0.00");
      }
    },
    [
      pair,
      valueCurr,
      valueCrypto,
      change,
      percentFee,
      minFee,
      minTransac,
      setValueCurr,
      setValueCrypto,
      setCryptoHubFee,
      setExchangeValue,
    ]
  );

  useEffect(() => {
    onChange("none", change);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pair, change]);

  const openSumsub = () => {
    fetchUpdate(userInfo.verif + 1).then((data) => {
      if (data) {
        setToken(data.token);
        setTimeout(() => {
          setIsPopupOpenVerification(true);
        }, 1000);
      } else {
        console.log("Error");
      }
    }
    );
  }

  useEffect(() => {
    setPopupOpenIsLimit(userInfo.verif === 0)
  }, [userInfo.verif])

  if (chatID) {
    return <Navigate to={`/chat/${chatID}`} />;
  }

  if (userInfo.type === 1) {
    return <Navigate to={`/transactions-list`} />;
  }

  const logout = () => {
    fetchLogout().then((data) => {
      updateUserInfo(dispatch, data.userData);
      dispatch(removeBankWalletAll());
      dispatch(removeCryptoWalletAll());
    });
  };

  return (
    <div className="exchange">
      <VerificationUser token={token} selectedCurr={selectedCurr} isPopupOpenVerification={isPopupOpenVerification} setIsPopupOpenVerification={setIsPopupOpenVerification} />

      <Popup isOpen={isPopupOpenLimit} onClose={() => null}>
        <div className="view-details">
          {/* <button onClick={closePopupLimit} className="close-popup">
            <i className="ri-close-line"></i>
          </button> */}
          <h3 className="px-32">{t("Exchange is unavailable until your identity is verified")}</h3>
          <img src={KYC} alt="" />
          {/* <p className="px-32">{t("Increase your daily turnover by verifying your identity with")} <span>KYC</span></p> */}
          <div className="wrapper-buttons">
            {/* <button onClick={closePopupLimit} className="form-default__cancel">
              {t("Cancel")}
            </button> */}
            <button onClick={() => openSumsub()} className="blue-button">
              {t("Start Verifying")}
            </button>
          </div>
          <Link className="form-default__cancel" to="/sign-in" onClick={logout}>
            <i className="ri-logout-box-line"></i>
            {t("Log out")}
          </Link>
        </div>

      </Popup>

      <Popup isOpen={isPopupOpenPreview} onClose={closePopupPreview}>
        <Preview selectedCurr={selectedCurr} change={change} selectedCoin={selectedCoin} errorShake={errorShake} exchangeValue={exchangeValue} cryptoHubFee={cryptoHubFee} minTransac={minTransac} pair={pair} closePopupPreview={closePopupPreview} bankWalletsInfo={bankWalletsInfo} cryptoWalletsInfo={cryptoWalletsInfo} preview={preview} userInfo={userInfo} minimumEuros={minimumEuros} handleExchange={handleExchange} />
      </Popup>


      <h1 className="heading mb-32">{t("Exchange your money")}</h1>
      <form
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
        onSubmit={handleSubmit}
      >
        <NewInputExchange
          pair={pair?.toString() || ""}
          lastUpdate={lastUpdate}
          walletsInfo={Array.isArray(bankWalletsInfo) ? bankWalletsInfo : []}
          setKeyWallet={setKeyWalletBank}
          change={change}
          type="bank"
          value={valueCurr || ""}
          selected={selectedCurr || { img: "", type: "", isCoin: false }}
          setSelected={setSelectedCurr}
          ref={refInputBank}
          selectedBuy={selectedCoin || ""}
          onChange={onChange || (() => { })}
          currencies={Array.isArray(allCurr) ? allCurr : []}
          setMethod={setMethod}
          keyWallet={keyWalletBank}
          style={{ marginBottom: "12px", paddingBottom: "28px", order: "0" }}
        />

        <NewInputExchange
          pair={pair?.toString() || ""}
          lastUpdate={lastUpdate}
          walletsInfo={Array.isArray(cryptoWalletsInfo) ? cryptoWalletsInfo : []}
          setKeyWallet={setKeyWalletCoin}
          change={!change}
          type="crypto"
          value={valueCrypto || ""}
          selected={selectedCoin || { img: "", type: "", isCoin: true }}
          setSelected={setSelectedCoin}
          ref={refInputCrypto}
          selectedBuy={selectedCurr || ""}
          onChange={onChange || (() => { })}
          currencies={Array.isArray(allCoin) ? allCoin : []}
          setMethod={setMethod}
          keyWallet={keyWalletCoin}
          style={{ marginBottom: "12px", paddingBottom: "28px", order: "0" }}
        />
        <div
          style={{ order: "3" }}
          onClick={reverseSwap}
          title={change ? "Change to sell cryptocurrency" : "Change to buy cryptocurrency"}
          className="reverse-swap"
        >
          <i className="ri-exchange-line"></i>
        </div>

        <div className="comision-fee">
          <p>
            {t("CryptoHub Fee:")}
            <span>{cryptoHubFee} {change ? selectedCurr.type.toUpperCase() : selectedCoin.type.toUpperCase()}</span>
          </p>
        </div>

        <button
          style={{ order: "3" }}
          className="form-default__submit"
          type="submit"
          disabled={checkChanges()}
        >
          {t("Pay ")} {
            exchangeValue
          } {change ? selectedCurr.type.toUpperCase() : selectedCoin.type.toUpperCase()}
        </button>
      </form>
    </div>
  );
};

export default NewExchange;